/* The privacy notice required by section 11 of the Privacy Protection Law, as
   amended by Amendment 13. It is deliberately one component used in two
   places — before sign-in from the landing page, and inside the workspace —
   so a learner never reads two different versions of the same promise.

   Every row of the table below describes something the system actually stores.
   When the data model changes, this file and PRIVACY_POLICY_VERSION change
   with it, and the server constant of the same name must be raised too. */

export const PRIVACY_POLICY_VERSION = '2026-08-11';
export const PRIVACY_CONTACT = 'rotgolan@gmail.com';
export const PRIVACY_CONTROLLER = 'גולן רוטנברג';

const COLLECTED = [
  {
    what: 'פרטי חשבון Google',
    detail: 'כתובת דוא״ל, שם תצוגה ותמונת פרופיל, כפי שהם מגיעים מ־Google בעת ההתחברות.',
    why: 'זיהוי הלומד, בקרת גישה, ויצירת קשר בענייני החשבון.',
  },
  {
    what: 'סטטוס הגישה',
    detail: 'האם החשבון ממתין, מאושר או חסום, מי אישר או חסם אותו ומתי.',
    why: 'אכיפת ההרשאה בשרת ותיעוד החלטות גישה.',
  },
  {
    what: 'התקדמות בלמידה',
    detail: 'מצב כל יחידה ושלב, נקודות ניסיון, רמה, רצפים, סמלי הישג ומוני שאלות.',
    why: 'הצגת ההתקדמות ושמירתה בין מכשירים.',
  },
  {
    what: 'טיוטות ותשובות שכתבת',
    detail: 'טקסט חופשי שאתה מקליד בשלבי התרגול והתוצר, ותשובותיך לבדיקות הידע.',
    why: 'שמירת עבודתך והערכתה מול חומר המקור.',
  },
  {
    what: 'היסטוריית פעילות',
    detail: 'רישום של פעולות למידה — פתיחת שלב, שמירה, השלמה, איפוס — עם חותמת זמן.',
    why: 'חישוב התקדמות ורצפים והצגת פעילות אחרונה.',
  },
  {
    what: 'שיחות עם עוזר ה־AI',
    detail: 'הנוסח המלא של השאלות שלך ושל התשובות שהתקבלו, ורשומות מחקר שנוצרו מהן.',
    why: 'המשכיות שיחה, חזרה לתשובות קודמות ותיעוד המחקר האישי שלך.',
  },
  {
    what: 'הגדרות AI אישיות',
    detail: 'המודל שבחרת, מועדי אימות חיבור, ומפתח OpenRouter אישי המוצפן ב־Cloud KMS.',
    why: 'הפעלת העוזר האישי בחשבון שלך בלבד.',
  },
  {
    what: 'רישומי אבטחה',
    detail: 'מוני הגבלת קצב, ויומן ביקורת של פעולות מנהל הנוגעות לחשבון.',
    why: 'הגנה מפני שימוש לרעה ויכולת לתחקר אירוע אבטחה.',
  },
];

const RECIPIENTS = [
  {
    who: 'Google',
    detail: 'Firebase Authentication, Firestore, Cloud Functions, Cloud Storage ו־Cloud KMS. כל המשאבים מוקמו באזור me-west1 בישראל. בנוסף פועל בדפים reCAPTCHA Enterprise לאימות שהפנייה מגיעה מהאתר המורשה, ו־Google אוספת במסגרתו אותות דפדפן ומכשיר למניעת שימוש לרעה.',
  },
  {
    who: 'OpenRouter',
    detail: 'מנתב את פניות עוזר ה־AI. מקבל את נוסח השאלה ואת מקטעי הידע שנשלחים איתה.',
  },
  {
    who: 'ספק המודל שבחרת',
    detail: 'מקבל את אותו תוכן דרך OpenRouter. הבחירה בידיך, ואפשר להחליף מודל או לנתק את החיבור בכל עת.',
  },
];

const RIGHTS = [
  {
    title: 'זכות עיון',
    body: 'בתצוגת "פרטיות ונתונים" אפשר להוריד קובץ שמכיל את כל המידע האישי שנשמר עליך במערכת. ההורדה מיידית ואינה דורשת פנייה.',
  },
  {
    title: 'זכות תיקון',
    body: 'השם, הדוא״ל ותמונת הפרופיל מגיעים מחשבון Google — תיקון שלהם שם מתעדכן כאן בהתחברות הבאה. התקדמות למידה ניתנת לאיפוס מתוך המערכת. לכל תיקון אחר אפשר לפנות לכתובת שלמטה, והמענה יינתן תוך 30 יום.',
  },
  {
    title: 'זכות מחיקה',
    body: 'אפשר למחוק את החשבון מתוך המערכת. המחיקה מסירה את הפרופיל, ההתקדמות, הטיוטות, ההיסטוריה, השיחות, הגדרות ה־AI והקבצים השמורים, ולבסוף את חשבון ההזדהות עצמו. הפעולה אינה הפיכה.',
  },
  {
    title: 'חריג יחיד למחיקה',
    body: 'יומן הביקורת של פעולות המנהל אינו נמחק, מפני שהוא הרשומה שמאפשרת לתחקר אירוע אבטחה בדיעבד. במחיקת חשבון מוסתרים ממנו כתובת הדוא״ל והמזהה שלך ובמקומם נרשם "[נמחק]". האירוע והמועד נשמרים; המידע המזהה אינו.',
  },
];

export default function PrivacyPolicy() {
  return (
    <article className="policy">
      <header className="policy-head">
        <span className="eyebrow">מדיניות פרטיות</span>
        <h1>איך סטודיום מטפלת במידע שלך</h1>
        <p className="policy-lede">
          המסמך הזה הוא הודעת היידוע לפי סעיף 11 לחוק הגנת הפרטיות, כנוסחו לאחר תיקון 13.
          הוא מתאר איזה מידע נאסף, למה, למי הוא מועבר, כמה זמן הוא נשמר, ואילו זכויות
          עומדות לך.
        </p>
        <p className="policy-version">גרסה {PRIVACY_POLICY_VERSION}</p>
      </header>

      <section className="policy-section">
        <h2>מי אחראי למידע</h2>
        <p>
          בעל המאגר הוא <strong>{PRIVACY_CONTROLLER}</strong>, שהוא גם הסופר אדמין היחיד
          של המערכת. לכל פנייה בנושא פרטיות:{' '}
          <a href={`mailto:${PRIVACY_CONTACT}`}>{PRIVACY_CONTACT}</a>.
        </p>
        <p>
          בהיקף הנוכחי אין למערכת חובת רישום מאגר, חובת הודעה לרשות להגנת הפרטיות או
          חובת מינוי ממונה הגנת הפרטיות — הספים שנקבעו בתיקון 13 לחובות אלה גבוהים
          משמעותית. חובות היידוע, ההסכמה, זכויות נושא המידע ואבטחת המידע חלות במלואן
          ומיושמות כמתואר כאן.
        </p>
      </section>

      <section className="policy-section">
        <h2>איזה מידע נאסף ולשם מה</h2>
        <div className="policy-table-wrap">
          <table className="policy-table">
            <thead>
              <tr><th>סוג המידע</th><th>מה נכלל</th><th>מטרת השימוש</th></tr>
            </thead>
            <tbody>
              {COLLECTED.map((row) => (
                <tr key={row.what}>
                  <th scope="row">{row.what}</th>
                  <td>{row.detail}</td>
                  <td>{row.why}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="policy-note">
          המערכת אינה אוספת מידע רפואי, גנטי, ביומטרי, פוליטי, דתי או פלילי, ואינה
          מבצעת פרופיילינג מסחרי, דיוור ישיר או מכירת מידע.
        </p>
      </section>

      <section className="policy-section">
        <h2>האם חובה למסור את המידע</h2>
        <p>
          מסירת המידע אינה חובה חוקית והיא נעשית מרצונך. עם זאת, בלי חשבון Google ובלי
          המידע המפורט למעלה לא ניתן לזהות אותך, לאשר לך גישה, לשמור את התקדמותך או
          להפעיל עבורך עוזר AI — כלומר לא ניתן לספק את השירות. הבסיס לעיבוד הוא הסכמתך
          ומתן השירות שביקשת.
        </p>
        <p>
          ההתחברות הראשונה מהווה הסכמה לנוסח שהוצג באותה עת, והמערכת רושמת את מספר
          הגרסה ואת מועד ההסכמה. כאשר המדיניות מתעדכנת תתבקש לאשר את הנוסח החדש. אפשר
          לחזור מההסכמה בכל עת על ידי מחיקת החשבון.
        </p>
      </section>

      <section className="policy-section">
        <h2>למי המידע מועבר</h2>
        <dl className="policy-list">
          {RECIPIENTS.map((row) => (
            <div key={row.who}>
              <dt>{row.who}</dt>
              <dd>{row.detail}</dd>
            </div>
          ))}
        </dl>
        <p className="policy-note">
          מעבר לאלה, המידע אינו נמסר לצד שלישי, אלא אם הדבר נדרש על פי דין או צו שיפוטי.
        </p>
      </section>

      <section className="policy-section">
        <h2>כמה זמן המידע נשמר</h2>
        <p>
          המידע נשמר כל עוד החשבון קיים, מפני שהוא מהווה את תיק הלמידה שלך. שיחה בודדת
          עם העוזר נמחקת מיד עם מחיקתה על ידך. מפתח ה־AI האישי נמחק עם ניתוק החיבור.
          עם מחיקת החשבון נמחק כל השאר, למעט ההסתרה ביומן הביקורת שתוארה למעלה.
        </p>
      </section>

      <section className="policy-section">
        <h2>הזכויות שלך</h2>
        <dl className="policy-list">
          {RIGHTS.map((row) => (
            <div key={row.title}>
              <dt>{row.title}</dt>
              <dd>{row.body}</dd>
            </div>
          ))}
        </dl>
        <p className="policy-note">
          לכל בקשה שאינה ניתנת לביצוע עצמי, המענה יינתן תוך 30 יום מקבלת הפנייה.
        </p>
      </section>

      <section className="policy-section">
        <h2>אבטחת המידע</h2>
        <ul className="policy-bullets">
          <li>הזדהות בחשבון Google מאומת בלבד; אין סיסמאות מקומיות ואין הרשמה עצמאית.</li>
          <li>ההרשאה נקבעת בשרת ב־Custom Claims ונאכפת גם בכללי Firestore.</li>
          <li>הנתונים האישיים אינם ניתנים לקריאה ישירה מהדפדפן; כל גישה עוברת דרך פונקציות שרת שמאמתות זהות ובעלות.</li>
          <li>מפתח ה־OpenRouter האישי מוצפן ב־Cloud KMS ואינו מוחזר לדפדפן לאחר השמירה.</li>
          <li>Firebase App Check מוודא שהפנייה מגיעה מהלקוח המורשה, ולצדו הגבלות קצב לכל פעולה.</li>
          <li>הפרדת נתונים מלאה: לומד ניגש למידע שלו בלבד.</li>
        </ul>
        <p className="policy-note">
          אם יתרחש אירוע אבטחה חמור, בעל המאגר ידווח לרשות להגנת הפרטיות כנדרש בחוק,
          ויידע את הנוגעים בדבר בהתאם להנחיית הרשות.
        </p>
      </section>

      <section className="policy-section">
        <h2>עוגיות ואחסון בדפדפן</h2>
        <p>
          המערכת אינה משתמשת בעוגיות פרסום או מדידה. בדפדפן נשמרים אסימוני ההזדהות של
          Firebase, ושתי העדפות תצוגה מקומיות שאינן מזהות אותך ואינן נשלחות לשרת.
          reCAPTCHA Enterprise, המשמש לאימות מקור הפנייה, פועל בכפוף למדיניות הפרטיות
          של Google.
        </p>
      </section>

      <section className="policy-section">
        <h2>שינויים במדיניות</h2>
        <p>
          לכל נוסח יש מספר גרסה. בעדכון מהותי תתבקש לאשר את הנוסח החדש בכניסה הבאה,
          וההסכמה תירשם מחדש.
        </p>
      </section>

      <section className="policy-section">
        <h2>פנייה ותלונה</h2>
        <p>
          לכל שאלה, בקשת עיון, תיקון או מחיקה:{' '}
          <a href={`mailto:${PRIVACY_CONTACT}`}>{PRIVACY_CONTACT}</a>. אם התשובה אינה
          מספקת אותך, עומדת לך הזכות לפנות לרשות להגנת הפרטיות במשרד המשפטים.
        </p>
      </section>

      <p className="policy-disclaimer">
        חומרי הלימוד במערכת עוסקים בדומיין מס סינתטי. הם אינם מתעדים מידע, סכימות,
        הרשאות או נהלים אמיתיים של ארגון כלשהו.
      </p>
    </article>
  );
}
